const initialState = () => ({
  promos: [],
  showActionModal: false, 
  actionModalView: '',
  imageFormOne: null,
  imageFormTwo: null,
  activeTab: 'active',
  selectedPromo: {},
  potentialUsers: [],
});
export default initialState;